import React, { useRef } from 'react';

import { iconsSources } from '../../helpers/icons';

import styles from './Message.module.css';
import { hideNumber } from '../../helpers/titreHelper';
import { useScrollText } from '../../hooks/useScrollText';

import hum from '../../assets/images/channel-none.png';

const Message = ({ className, message, withCircles, getParams }) => {
  const contentRef = useRef();
  const contentContainerRef = useRef();

  const {
    msgAvatarShadowColor,
    msgNameTextColor,
    msgNameBgColorStart,
    msgNameBgColorStop,
    msgNameColorDirection,
    msgContentTextColor,
    // цветные круги
    circleTopBgColorStart,
    circleTopBgColorStop,
    circleTopColorDirection,
    circleBottomBgColorStart,
    circleBottomBgColorStop,
    circleBottomColorDirection,
  } = getParams;

  useScrollText(contentRef, contentContainerRef, message?.content);

  const handleError = (e) => {
    e.target.src = iconsSources[message?.channel] || hum;
  };

  return (
    <div className={className}>
      <div className={styles['wrapper']}>
        {message?.content && (
          <>
            <div
              className={styles['avatar']}
              style={{ boxShadow: `0 -0.4rem ${msgAvatarShadowColor}` }}>
              <img
                src={
                  (message?.image &&
                    message?.image !== '1' &&
                    message?.image) ||
                  iconsSources[message?.channel] ||
                  hum
                }
                alt={message?.author}
                onError={handleError}
              />
            </div>
            <div className={styles['content']}>
              <div
                className={styles['name']}
                style={{
                  color: msgNameTextColor,
                  backgroundImage: `linear-gradient(${msgNameColorDirection}deg, ${msgNameBgColorStart}, ${msgNameBgColorStop})`,
                }}>
                {message?.author || hideNumber(message?.senderNumber)}
              </div>
              <div className={styles['text-wrapper']} ref={contentContainerRef}>
                <div
                  className={styles['text']}
                  ref={contentRef}
                  style={{ color: msgContentTextColor }}>
                  {message?.content}
                </div>
              </div>
            </div>
          </>
        )}
        {withCircles && (
          <>
            <span
              className={styles['buble1']}
              style={{
                backgroundImage: `linear-gradient(${circleTopColorDirection}deg, ${circleTopBgColorStart}, ${circleTopBgColorStop})`,
              }}></span>
            <span
              className={styles['buble2']}
              style={{
                backgroundImage: `linear-gradient(${circleBottomColorDirection}deg, ${circleBottomBgColorStart}, ${circleBottomBgColorStop})`,
              }}></span>
          </>
        )}
      </div>
    </div>
  );
};

export default React.memo(Message);
